import { List as AntdList, ListProps } from "antd";
import React from "react";

const List = <T,>(props: ListProps<T>) => {
  return <AntdList {...props} />;
};

List.Item = AntdList.Item;

export default List;
